<template>
    <div>
        <part-item :title="$t('partner')">
            <content-item :marginTop="0">
                <div class="partner-content">
                    <div class="hex-row" v-for="row in 4" :class="row % 2 == 0 ? 'hex-gap' : ''">
                        <template v-if="row % 2 == 0">
                            <div class="hex-col" v-for="col in 8">
                                <div class="hexagon" :class="'icon'+ row + '' + col">
                                    <div class="content" v-if="showIcon(row, col)">
                                        <img  v-lazy="'../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'"
                                             class="icon">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="hex-col" v-for="col in 8">
                                <div class="hexagon" :class="'icon'+row + '' + col">
                                    <div class="content" v-if="showIcon(row, col)">
                                        <img v-lazy="'../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'"
                                             class="icon">
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

            </content-item>
        </part-item>
    </div>
</template>

<script>
    import PartItem from '../partial/PartItem.vue'
    import ContentItem from '../partial/ContentItem.vue'

    export default {
        data: function () {
            return {}
        },
        methods: {
            showIcon(row, col) {
                if (row == 1 && col == 5) {
                    return false;
                }
                if (row == 2 && (col == 2 || col == 6)) {
                    return false;
                }
                if (row == 3 && col == 4) {
                    return false;
                }
                if (row == 4 && (col == 2 || col == 7)) {
                    return false;
                }
                return true;
            }
        },
        components: {
            PartItem,
            ContentItem
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib";

    .partner-content {
        margin: 30px auto;
        .hex-row {
            @include flex;
            margin-top: -18px;
            margin-left: 5px;
            .hex-col {
                margin-right: 14px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .hex-gap {
            margin-left: 62px;
        }
    }

    .icon15 {
        @include hexagon(#ff6262, #ff9191);
        transform: rotate(-60deg);
    }

    .icon22 {
        @include hexagon(#fd8b4c, #feae82);
        transform: rotate(-60deg);
    }

    .icon26 {
        @include hexagon(#ec54a9, #f288c3);
        transform: rotate(120deg);
    }

    .icon34 {
        @include hexagon(#12a765, #5ac294);
    }

    .icon42 {
        @include hexagon(#3683c7, #73a8d8);
        transform: rotate(-60deg);
    }

    .icon47 {
        @include hexagon(#def068, #e8f596);
    }


    .hexagon {
        @include hexagon();
    }
</style>


// WEBPACK FOOTER //
// Partner.vue?a4d5a99a